import React from "react"

export default function SubmitButton({ id, label = "Submit", description, displayOption, formStepsCount, previousStepLabel, goBack }) {
  const submitButton = () => {
    return (
      <button
        tabIndex={0}
        id={id}
        name="submit"
        type="submit"
        value={id}
        className={`button button--submit button--medium button--general no-shadow casc-blue Form__Element ${formStepsCount > 0 ? "displaymode-half" : displayOption}`}
        data-f-is-finalized={true}
        data-f-is-progressive-submit={true}
        data-f-type="submitbutton"
        title={description}
        aria-label={description}
      >
        <span className="text">{label}</span>
      </button>
    )
  }

  if (formStepsCount > 0) {
    return (
      <>
        <button type="button" className={`button button--medium button--general button--reset Form__Element displaymode-half`} onClick={goBack}>
          {previousStepLabel || "Tilbage"}
        </button>
        {submitButton()}
      </>
    )
  }

  return submitButton()
}
